var map = {
	"./DROP_DOWN.svg": 530,
	"./ic_arbitrum_16.svg": 876,
	"./ic_avalanche_16.svg": 877,
	"./ic_avax_40.svg": 878,
	"./ic_bnb_40.svg": 879,
	"./ic_btc_40.svg": 880,
	"./ic_coingecko_16.svg": 881,
	"./ic_convert_down.svg": 882,
	"./ic_copy_16.svg": 883,
	"./ic_eth_40.svg": 627,
	"./ic_frax_40.svg": 884,
	"./ic_glp_24.svg": 885,
	"./ic_glp_40.svg": 886,
	"./ic_link_40.svg": 887,
	"./ic_metamask_16.svg": 888,
	"./ic_mim_40.svg": 889,
	"./ic_new_link_16.svg": 890,
	"./ic_settings_16.svg": 891,
	"./ic_sign in_16.svg": 892,
	"./ic_sign_out_16.svg": 893,
	"./ic_uni_40.svg": 894,
	"./ic_usdc.e_40.svg": 895,
	"./ic_usdc_40.svg": 896,
	"./ic_usdt_40.svg": 897,
	"./ic_wavax_40.svg": 898,
	"./ic_wbnb_40.svg": 899,
	"./ic_weth_40.svg": 900,
	"./lever.svg": 901,
	"./long.svg": 902,
	"./short.svg": 903,
	"./swap.svg": 904,
	"./swapup.svg": 905,
	"./wave-01.png": 906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875;